export default __webpack_public_path__ + "static/Get-started-883238d2048bf7c19319456fd94ca9ca.png";